<template>
  <div v-if="dataWasDownloadedSuccessfully">

    <!-- Start Filter Tabs -->
    <div id="btnContainer" class="d-flex column-gap-1">
      <button class="btn btn-tag mb-2" v-for="year in years" :key="year" :class="{active : active_btn === year }"
        @click="activate(year)" v-on:click="filterSelection(year)">{{year}}</button>
        
      <button class="btn btn-tag mb-2" :class="{active : active_btn === 'all'}" @click="activate('all')"
        v-on:click="filterSelection('all')">Alles</button>
    </div>
    <!-- End Filter Tabs -->

    <!-- Start Articles -->
    <div class="blog-entries">
      <article v-for="(post, idx) in filteredPorts" class="my-5 filter-element animate__animated show animate__fadeInUp"
        :key="idx">
        <h4 class="mb-2">{{ post.fields.postTitle }}</h4>
        <small class="text-muted">{{ post.fields.postDate }}</small>
        
        <div class="d-flex flex-column flex-md-row column-gap-4 mt-3">
          <div class="flex-basis-full" v-html="post.fields.description"></div>
          <div class="flex-basis-full" v-if="(post.fields.image)">  
            <p>
              <img :src="post.fields.image.fields.file.url" alt="Bild von post.fields.postTitle" />
            </p>
          </div>
        </div>

      </article>
    </div>
    <!-- End Articles -->

  </div>
</template>

<script>
  import { getContent } from '@/javascripts/contentful';
  import { INLINES } from '@contentful/rich-text-types';
  import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
    import { load } from 'recaptcha-v3';

  import axios  from 'axios';
  import helpers from '../javascripts/helpers';

  // application/json is not supported by CORS
  axios.defaults.headers.post['Content-Type'] = 'text/plain';

  const recaptchaRenderParams = {
    explicitRenderParameters: {
      badge: 'bottomleft',
    },
  };

  export default {
    name: 'articlesApp',
    props: [
      "articles",
    ],
    data() {
      return {
        active_btn: 'all',
        years: [],
        posts: [],
        filteredPorts: [],
        dataWasDownloadedSuccessfully: false
      }
    },
    async mounted() {
      const { fields } = await getContent(this.articles.sys.id)

      if (fields) {
        const parsed = [];

        for (const post of fields.post) {
          const description = documentToHtmlString(post.fields.artikelInhaltOderCode, {
            renderNode: {
              [INLINES. HYPERLINK]: (node, next) => {
                return `<a href="${node.data.uri}" target="_blank">${next(node.content)}</a>`;
              }
            }
          })

          parsed.push({
            ...post,
            fields: {
              ...post.fields,
              description
            },
          })
        }

        this.posts = [...parsed];
        this.dataWasDownloadedSuccessfully = true
        _.each(this.posts, (post) => {
          this.years.push(new Date(post.fields.postDate).getFullYear())
        })

        this.years = _.uniq(this.years)
        const mostRecentYear = Math.max(...this.years.map(o => o), 0);
        if (mostRecentYear) {
          this.active_btn = Math.max(...this.years.map(o => o), 0)
          this.filteredPorts = this.posts.filter(post => new Date(post.fields.postDate).getFullYear() === mostRecentYear)
        } else {
          this.filteredPorts = this.posts
        }
      }
    },
    methods: {
      filterSelection(year) {
        if (year !== 'all') {
          this.filteredPorts = this.posts.filter(post => new Date(post.fields.postDate).getFullYear() === year)
        } else {
          this.filteredPorts = this.posts
        }
      },
      activate(el) {
        this.active_btn = el;
      }
    }
  }
</script>
